<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Report</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <inputbox
            v-model="form.incident_number"
            name="incident_number"
            helper="Please enter the incident number of the police report"
            label="Incident Number"
          ></inputbox>

          <inputbox
            v-model="form.officer_name"
            name="officer_name"
            label="Officer Name / No"
            helper="Please enter the officers name who created the report"
          ></inputbox>

          <inputbox
            v-model="form.telephone"
            name="telephone"
            label="Telephone"
            helper="Please enter a contact number for the police report"
          ></inputbox>

          <toggleswitch
            :labels="true"
            name="officer_attended"
            label="Did the officer attend the incident?"
            v-model="form.officer_attended"
          ></toggleswitch>

          <div class="form-group">
            <div class="col-lg-4">
              <label for="incident_reported_at" class="control-label"
                >Incident Reported:</label
              >
              <p class="help-block">
                According to the report, please enter the date when the incident
                was reported.
              </p>
            </div>
            <div class="col-lg-8">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.incident_reported_at"
                v-on:selected="setIncidentReportedDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <div class="form-group">
            <div class="col-lg-4">
              <label for="report_requested_at" class="control-label"
                >Report Requested:</label
              >
              <p class="help-block">
                Please enter the date the police report was requested
              </p>
            </div>
            <div class="col-lg-8">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.report_requested_at"
                v-on:selected="setReportRequestedDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <div class="form-group">
            <div class="col-lg-4">
              <label for="report_received_at" class="control-label"
                >Report Received:</label
              >
              <p class="help-block">
                Please enter the date the report was received
              </p>
            </div>
            <div class="col-lg-8">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.report_received_at"
                v-on:selected="setReportReceivedDate"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
              ></datepicker>
            </div>
          </div>

          <toggleswitch
            :labels="true"
            name="client_breathalysed"
            label="Was the Client Breathalysed?"
            v-model="form.client_breathalysed"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="third_party_breathalysed"
            label="Was the TP Breathalysed?"
            v-model="form.third_party_breathalysed"
          ></toggleswitch>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="addReport"
        >Add New Report</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      form: new window.Form({
        incident_number: null,
        officer_name: null,
        telephone: null,
        officer_attended: false,
        incident_reported_at: null,
        report_requested_at: null,
        report_received_at: null,
        client_breathalysed: false,
        third_party_breathalysed: false
      })
    };
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    addReport() {
      this.form
        .post('/incidents/' + this.incident + '/police-reports')
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {});
    },

    setIncidentReportedDate(value) {
      this.form.incident_reported_at = value;
    },

    setReportRequestedDate(value) {
      this.form.report_requested_at = value;
    },

    setReportReceivedDate(value) {
      this.form.report_received_at = value;
    }
  }
};
</script>
